"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.determinePaymentMethod = determinePaymentMethod;
exports.setPaymentTab = setPaymentTab;
var module_mapping_1 = require("@src/const/module.mapping");
var cash_dom_1 = __importDefault(require("cash-dom"));
function determinePaymentMethod(paymentTabs) {
    var _a;
    var paymentChoice = (_a = paymentTabs === null || paymentTabs === void 0 ? void 0 : paymentTabs.querySelector('.w--current')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-w-tab');
    if (!paymentChoice) {
        return {
            original: 'stripe',
            value: 'DIRECT_DEBIT',
            type: 'magicline',
        };
    }
    var original = paymentChoice;
    paymentChoice = paymentChoice.toLowerCase();
    var magicLineMappings = {
        sepa: 'DIRECT_DEBIT',
        ueberweisung: 'DIRECT_DEBIT',
    };
    var stripeMappings = {
        klarna: 'klarna',
        paypal: 'paypal',
        kreditkarte: 'card',
        ideal: 'ideal',
        sofort: 'sofort',
    };
    if (magicLineMappings[paymentChoice]) {
        return {
            original: original,
            value: magicLineMappings[paymentChoice],
            type: 'magicline',
        };
    }
    else if (stripeMappings[paymentChoice]) {
        return {
            original: original,
            value: stripeMappings[paymentChoice],
            type: 'stripe',
        };
    }
    return { original: original, value: paymentChoice, type: 'unknown' };
}
// PayPal is the tab name of stripe/fitpay, Sepa is the tab name of magiclines IBAN payment
function setPaymentTab(tab) {
    var fitpaySwitcher = (0, cash_dom_1.default)("[data-ref='".concat(module_mapping_1._MembershipCompletionReferences.fitpayPaymentSwitcher.uid, "']"));
    if (fitpaySwitcher.length) {
        var tabElem = fitpaySwitcher.find("[data-w-tab=\"".concat(tab, "\"]"));
        if (tabElem.length) {
            tabElem[0].click();
        }
    }
}
